import * as React from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import SocialAuth from '../../SocialAuth';
import { BaseButton, ModalX } from '../../BaseComponents';
import { useTheme } from '../../theme';
import { LoginFormModal } from '../../LoginPage';
import { OauthServiceType } from '@websky/graphql';

interface Props {
	isOpen?: boolean;
	onClose?: () => void;
	onSuccess: (isRegistration?: boolean) => void;
	onReject: () => void;
	onSocialAuthClick?: (service: OauthServiceType) => void;
}

const MobileAuthForm: React.FC<Props> = ({ onSuccess, onReject, onSocialAuthClick, ...modalProps }) => {
	const [showLoginForm, setShowLoginForm] = useState(false);
	const { MobileAuthForm: css } = useTheme('MobileAuthForm');
	const { t } = useTranslation('MobileAuthForm');

	const openLoginForm = () => setShowLoginForm(true);

	return !showLoginForm ? (
		<ModalX {...modalProps} size="medium">
			<h1 className={css.title}>{t('Sign in')}</h1>

			<p className={css.sub}>{t('and fill in passengers info with a single click')}.</p>

			<div className={css.social}>
				<SocialAuth onClick={onSocialAuthClick} variant="square" />
			</div>

			<p className={css.email} onClick={openLoginForm}>
				{t('Sign in with email')}
			</p>

			<BaseButton className={css.button} size="large" variant="smallSecondary" onClick={onReject}>
				{t('Continue as a guest')}
			</BaseButton>
		</ModalX>
	) : (
		<LoginFormModal modalProps={{ ...modalProps }} loginFormProps={{ onSuccess: onSuccess }} />
	);
};

export default MobileAuthForm;
